/**
 * @description: 打印单据设置
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="store-set-print">
        <!-- 商品总单打印设置 -->
        <div class="store-szd-set" v-show="show1">
            <div class="szd-list">
                <h1 class="title">商品总单打印设置</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="szdList" style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(1)">返回</button>
                </div>
            </div>
            <div class="szd-modify">
                <div class="page-tit">商品总单打印设置</div>
                <div class="row">
                    <label class="col-md-1 ctr-label-left">适用门店：</label>
                    <div class="col-md-6 szd-modify-shop">
                        {{szd_shop_name}}
                    </div>
                </div>
                <div class="row rowpadding">
                    <label class="col-md-1 ctr-label-left">打印总单设置：</label>
                    <div class="col-md-6 szd-sel-list">
                        <h3>请选择需要打印的商品总单</h3>
                        <ul class="clearfix">
                            <li @click="szdSel('1')">微信自助下单</li>
                            <li @click="szdSel('2')">触摸屏员工下单</li>
                            <li @click="szdSel('3')">app下单（安卓一体机）</li>
                            <li @click="szdSel('4')">app下单（非一体机）</li>
                            <li @click="szdSel('5')">商品赠送总单</li>
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backSzdList">返回</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;" @click="szdSub()">确定</button>
                </div>
            </div>
        </div>


        <!-- 账单是否自动打印 -->
        <div class="store-iszd-set" v-show="show2">
            <div class="iszd-list">
                <h1 class="title">账单是否自动打印</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="iszdList" style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(2)">返回</button>
                </div>
            </div>
        </div>


        <!-- 账单打印是否显示赠送商品金额 -->
        <div class="store-zdj-set" v-show="show3">
            <div class="zdj-list">
                <h1 class="title">账单打印是否显示赠送商品金额</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="zdjList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(3)">返回</button>
                </div>
            </div>
        </div>


        <!-- 取酒单是否显示已取和剩余酒水明细 -->
        <div class="store-qjm-set" v-show="show4">
            <div class="qjm-list">
                <h1 class="title">取酒单是否显示已取和剩余酒水明细</h1>
                <p class="p-hint">注：打印的取酒单设置是时显示出已取酒明细和剩余酒水明细，设置否时则只显示本次取酒商品明细。</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="qjmList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(4)">返回</button>
                </div>
            </div>
        </div>


        <!-- 打印的单据是否自动打印 -->
        <div class="store-dzd-set" v-show="show5">
            <div class="dzd-list">
                <h1 class="title">打印的单据是否自动打印</h1>
                <p class="p-hint">注：选中【是】时有设置过打印规则的可自动打印出单，选中【否】时有设置过打印规则时自动打印的单据均不打印。</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="dzdList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(5)">返回</button>
                </div>
            </div>
        </div>


        <!-- 开房单备注设置 -->
        <div class="store-kfb-set" v-show="show6">
            <div class="kfb-list">
                <h1 class="title">开房单备注设置</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="kfbList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(6)">返回</button>
                </div>
            </div>
            <div class="kfb-bill" ref="kfb_bill">
                <div>
                    <h2>开房单</h2>
                    <div class="row">
                        <label>消费包厢：</label>
                        <span>XXXXXX</span>
                    </div>
                    <div class="row">
                        <label>订单编号：</label>
                        <span>XXXXXX</span>
                    </div>
                    <div class="row">
                        <label>包厢类型：</label>
                        <span>XXXXXX</span>
                    </div>
                    <div class="row">
                        <label>名称：</label>
                        <span>XXXXXX</span>
                    </div>
                    <div class="row">
                        <label>预定信息：</label>
                        <span>XXXXXX</span>
                    </div>
                    <div class="row">
                        <p v-for="(item, index) in kfb_remark" :key="index">{{item}}</p>
                    </div>
                    <div class="row">
                        <label>贵宾签名：</label>
                        <span>XXXXXX</span>
                    </div>
                    <div class="row">
                        <label>服务员：</label>
                        <span>XXXXXX</span>
                    </div>
                    <div class="row">
                        <label>开房时单价：</label>
                        <span>XXXXXX</span>
                    </div>
                </div>
            </div>
        </div>


        <!-- 交接单底部是否留白 -->
        <div class="store-jdb-set" v-show="show7">
            <div class="jdb-list">
                <h1 class="title">交接单底部是否留白</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="jdbList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(7)">返回</button>
                </div>
            </div>
        </div>


        <!-- 账单的门店地址和电话是否隐藏 -->
        <div class="store-ddy-set" v-show="show8">
            <div class="ddy-list">
                <h1 class="title">账单的门店地址和电话是否隐藏</h1>
                <p class="p-hint">注：选择【是】的时打印的账单上的门店地址和电话内容将被隐藏</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="ddyList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(8)">返回</button>
                </div>
            </div>
        </div>


        <!-- 账单结尾内容定义 -->
        <div class="store-zjn-set" v-show="show9">
            <div class="zjn-list">
                <h1 class="title">账单结尾内容定义</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="zjnList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(9)">返回</button>
                </div>
            </div>
            <!-- 修改 -->
            <div class="use-time-wrap" ref="zjn_usetime_alert">
                <div class="zjn-usetime-allday">
                    <input type="checkbox" v-model="zjn_usetime_allday" value="1">
                    <label>无</label>
                </div>
                <div class="row">
                    <input type="text" class="form-control" placeholder="请输入内容" ref="zjn_txt" v-model="zjn_txt" />
                </div>
            </div>
        </div>


        <!-- 员工还款后打印商品订单 -->
        <div class="store-yhd-set" v-show="show10">
            <div class="yhd-list">
                <h1 class="title">员工还款后打印商品订单</h1>
                <p class="p-hint">注：选择【否】员工账户支付的订单支付成功后打印。选择【是】时员工支付的订单需要员工确定还款后打印。</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="yhdList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(10)">返回</button>
                </div>
            </div>
        </div>


        <!-- 打印单据的会员信息是否隐藏 -->
        <div class="store-dyx-set" v-show="show11">
            <div class="dyx-list">
                <h1 class="title">打印单据的会员信息是否隐藏</h1>
                <p class="p-hint">注：选择【是】的时候，打印的单据上的会员卡号、手机号、姓名的部分内容会以*号代替</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="dyxList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(11)">返回</button>
                </div>
            </div>
        </div>


        <!-- 付款记录是否隐藏 -->
        <div class="store-fsk-set" v-show="show12">
            <div class="fsk-list">
                <h1 class="title">付款记录是否隐藏</h1>
                <p class="p-hint">注：选择“是”时，打印的账单单据不显示付款和退款的流水记录</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="fskList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(12)">返回</button>
                </div>
            </div>
        </div>

        <!-- 账单打印内容是否包含送花账单信息 -->
        <div class="store-zdbs-set" v-show="show13">
            <div class="zdbs-list">
                <h1 class="title">账单打印内容是否包含送花账单信息</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="zdbsList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(13)">返回</button>
                </div>
            </div>
        </div>

        <!-- 商品备货单是否显示合计金额 -->
        <div class="store-sbh-set" v-show="show14">
            <div class="sbh-list">
                <h1 class="title">商品备货单是否显示合计金额</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="sbhList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(14)">返回</button>
                </div>
            </div>
        </div>

        <!-- 账单打印是否显示套餐明细金额 -->
        <div class="store-zdxtm-set" v-show="show15">
            <div class="iszd-list">
                <h1 class="title">账单打印是否显示套餐明细</h1>
                <p class="p-hint">注：是否显示套餐明细：【否】打印的账单不显示套餐明细商品，包含开房套餐明细和商品套餐明细</p>
                <p class="p-hint">是否显示套餐明细金额：【是】则打印的账单内容包含套餐时，会显示套餐明细商品的金额</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="zdxtmList" style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(15)">返回</button>
                </div>
            </div>
        </div>

         <!-- 账单打印是否显示低消金额 -->
        <div class="store-zdxdx-set" v-show="show16">
            <div class="iszd-list">
                <h1 class="title">账单打印是否显示低消金额</h1>
                <p class="p-hint">注：选择“是”，则打印的账单显示对应相关低消的金额</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="zdxdxList" style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(16)">返回</button>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                show1: false,
                show2: false,
                show3: false,
                show4: false,
                show5: false,
                show6: false,
                show7: false,
                show8: false,
                show9: false,
                show10: false,
                show11: false,
                show12: false,
                show13: false,
                show14: false,
                show15: false,
                show16: false,

                // 商品总单打印设置
                szd_shop_id: '',
                szd_shop_name: '',
                szd_auto_receive: [],

                // 开房单备注设置
                kfb_remark: [],

                // 账单结尾内容定义
                zjn_usetime_allday: '',
                zjn_txt: '',
            }
        },
        watch: {
            // 账单结尾内容定义
            zjn_usetime_allday: {
                handler: function(val, oldVal) {
                    if(val == '1') {
                        $(this.$refs.zjn_txt).attr('disabled', true);
                    } else {
                        $(this.$refs.zjn_txt).attr('disabled', false);
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            
        },
        methods: {
            // 显示页面
            showTargetPage(num) {
                this[`show${num}`] = true

                if(num == '1') {
                    this.innitSzdTable()
                } else if(num == '2') {
                    this.innitIszdTable()
                } else if(num == '3') {
                    this.innitZdjTable()
                } else if(num == '4') {
                    this.innitQjmTable()
                } else if(num == '5') {
                    this.innitDzdTable()
                } else if(num == '6') {
                    this.innitKfbTable()
                } else if(num == '7') {
                    this.innitJdbTable()
                } else if(num == '8') {
                    this.innitDdyTable()
                } else if(num == '9') {
                    this.innitZjnTable()
                } else if(num == '10') {
                    this.innitYhdTable()
                } else if(num == '11') {
                    this.innitDyxTable()
                } else if(num == '12') {
                    this.innitFskTable()
                } else if(num == '13') {
                    this.innitZdbsTable()
                } else if(num == '14') {
                    this.innitSbhTable()
                } else if(num == '15') {
                    this.innitZdxtmTable()
                } else if(num == '16') {
                    this.innitZdxdxTable()
                }
            },
            // 返回
            backIndex(index) {
                this[`show${index}`] = false
                this.$emit('targetBack')
            },


            /*
             * 商品总单打印设置
             */
            // 初始化商品总单打印设置
            innitSzdTable: function() {
                let _this = this;
                $(_this.$refs.szdList).bootstrapTable('destroy');
                $(_this.$refs.szdList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getSzdList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "bills_print_setting_show",
                        title: "打印的总单",
                        width: "30%"
                    }, {
                        title: "操作",
                        width: "30%",
                        events: {
                            'click .modify': function(e, value, row) {
                                _this.szd_shop_id = row.shop_id;
                                _this.szd_shop_name = row.shop_name;
                                $('.szd-sel-list li').removeClass('szd-sel-li');
                                if(row.bills_print_setting == '无') {
                                    _this.szd_auto_receive = [];
                                } else {
                                    _this.szd_auto_receive = row.bills_print_setting;
                                    $.each(_this.szd_auto_receive, function(k, v) {
                                        $('.szd-sel-list li').eq(v - 1).addClass('szd-sel-li');
                                    });
                                }
                                $('.szd-list').hide();
                                $('.szd-modify').show();
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue modify">修改</span>'
                        }
                    }]
                });
            },
            // 商品总单打印设置
            getSzdList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "shop/getBillsPrintSetting",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 选择任务
            szdSel: function(num) {
                let index = this.szd_auto_receive.indexOf(num);
                if(index == '-1') {
                    this.szd_auto_receive.push(num);
                    $('.szd-sel-list li').eq(num - 1).addClass('szd-sel-li');
                } else {
                    this.szd_auto_receive.splice(index, 1);
                    $('.szd-sel-list li').eq(num - 1).removeClass('szd-sel-li');
                }
            },
            // 返回
            backSzdList: function() {
                $('.szd-list').show();
                $('.szd-modify').hide();
            },
            // 修改
            szdSub: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": _this.szd_shop_id,
                            "bills_print_setting": _this.szd_auto_receive
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/setBillsPrintSetting",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            $(_this.$refs.szdList).bootstrapTable('refresh')
                            $('.szd-list').show();
                            $('.szd-modify').hide();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * 账单是否自动打印
             */
            // 初始化账单是否自动打印
            innitIszdTable: function() {
                let _this = this;
                $(_this.$refs.iszdList).bootstrapTable('destroy');
                $(_this.$refs.iszdList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.geIszdList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "auto_print_bill",
                        title: "账单是否自动打印",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.iszdSub(row.shop_id, check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(row.auto_print_bill == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 账单是否自动打印列表
            geIszdList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAutoPrintBillSetting",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 账单是否自动打印设置
            iszdSub: function(shop_id, check_stock) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            "auto_print_bill": check_stock
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/setAutoPrintBillSetting",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            $(_this.$refs.iszdList).bootstrapTable('refresh')
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * 账单打印是否显示赠送商品金额
             */
            innitZdjTable: function() {
                let _this = this;
                $(_this.$refs.zdjList).bootstrapTable('destroy');
                $(_this.$refs.zdjList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.geZdjList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "序号",
                        width: "10%",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "bill_show_present_amount",
                        title: "账单打印是否显示赠送商品总金额",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.zdjSub(row.shop_id, 'bill_show_present_amount', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "bill_show_present_goods_amount",
                        title: "账单打印是否显示赠送商品明细金额",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.zdjSub(row.shop_id, 'bill_show_present_goods_amount', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 账单是否自动打印列表
            geZdjList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getBillShowPresentAmountSetting",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 账单是否自动打印设置
            zdjSub: function(shop_id, key, check_stock) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            [key]: check_stock
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/setBillShowPresentAmountSetting",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            $(_this.$refs.zdjList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * 取酒单是否显示已取和剩余酒水明细
             */
            innitQjmTable: function() {
                let _this = this;
                $(_this.$refs.qjmList).bootstrapTable('destroy')
                $(_this.$refs.qjmList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getQjmList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "deposit_bill_setting",
                        title: "取酒单是否显示已取和剩余酒水明细",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.qjmSub(row.shop_id, check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            getQjmList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "config_type": "deposit_bill_setting"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getConfigList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 设置
            qjmSub: function(id, check_stock) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "config": check_stock,
                            "config_type": "deposit_bill_setting"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/upConfig",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg('设置成功');
                            $(_this.$refs.qjmList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * 打印的单据是否自动打印
             */
            innitDzdTable: function() {
                let _this = this;
                $(_this.$refs.dzdList).bootstrapTable('destroy')
                $(_this.$refs.dzdList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getDzdList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "auto_print",
                        title: "打印的单据是否自动打印",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.dzdSub(row.shop_id, check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            getDzdList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "config_type": "auto_print"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getConfigList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 设置
            dzdSub: function(id, check_stock) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "config": check_stock,
                            "config_type": "auto_print"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/upConfig",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg('设置成功');
                            $(_this.$refs.dzdList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * 开房单备注设置
             */
            innitKfbTable: function() {
                let _this = this;
                $(_this.$refs.kfbList).bootstrapTable('destroy');
                $(_this.$refs.kfbList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getKfbList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "适用门店",
                        valign: 'middle',
                        width: "30%"
                    }, {
                        field: "open_room_remark",
                        title: "开房单备注内容",
                        width: "50%",
                        valign: 'middle',
                        events: {
                            'blur .kfb-remark': function(e, value, row) {
                                _this.kfbSub(row.shop_id, $(this).val().replace(/\n/g, '{EN}'));
                            },
                            'click .kfb-css': function(e, value, row) {
                                _this.kfb_remark = value.split(/{EN}/g);
                                layer.open({
                                    type: 1,
                                    title: '样式查看',
                                    skin: 'public-alert-skin',
                                    area: ['500px', ''], //宽高
                                    content: $(_this.$refs.kfb_bill)
                                });
                            }
                        },
                        formatter: function(value, row, index) {
                            return `<textarea class="kfb-remark">${ value.replace(/{EN}/g, '\n') }</textarea><span class="text-blue pull-right kfb-css">样式查看</span>`;
                        }
                    }]
                });
            },
            // 列表
            getKfbList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "config_type": "open_room_remark"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getConfigList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 设置
            kfbSub: function(id, check_stock) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "config": check_stock,
                            "config_type": "open_room_remark"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/upConfig",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg('操作成功');
                            $(_this.$refs.kfbList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * 交接单底部是否留白
             */
            innitJdbTable: function() {
                let _this = this;
                $(_this.$refs.jdbList).bootstrapTable('destroy');
                $(_this.$refs.jdbList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getJdbList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "shift_turnover_lb",
                        title: "打印的交接单底部是否留白",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.jdbSub(row.shop_id, check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 列表
            getJdbList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Printer/getConfigList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 设置
            jdbSub: function(shop_id, check_stock) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            "shift_turnover_lb": check_stock
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Printer/editConfig",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg('修改成功');
                            $(_this.$refs.jdbList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * 账单的门店地址和电话是否隐藏
             */
            innitDdyTable: function() {
                let _this = this;
                $(_this.$refs.ddyList).bootstrapTable('destroy');
                $(_this.$refs.ddyList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getDdyList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "bill_hide_contact",
                        title: "账单的门店地址和电话是否隐藏",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.ddySub(row.shop_id, check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 列表
            getDdyList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                Vue.axios.post('Printer/getConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.total,
                            rows: res.data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 设置
            ddySub: function(shop_id, check_stock) {
                const _this = this;

                Vue.axios.post('Printer/editConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            "bill_hide_contact": check_stock
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.ddyList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },


            /*
             * 账单结尾内容定义
             */
            innitZjnTable: function() {
                let _this = this;
                $(_this.$refs.zjnList).bootstrapTable('destroy');
                $(_this.$refs.zjnList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getZjnList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "bill_foot_content",
                        title: "账单结尾内容定义",
                        width: "30%",
                        events: {
                            'click .edit': function(e, value, row) {
                                if(value == '') {
                                    _this.zjn_usetime_allday = '1';
                                    _this.zjn_txt = '';
                                } else {
                                    _this.zjn_usetime_allday = '';
                                    _this.zjn_txt = value;
                                }
                                _this.zjnSub(row.shop_id);
                            }
                        },
                        formatter: function(value, row, index) {
                            if(value == '') {
                                return '<span class="text-blue edit">无</span>';
                            } else {
                                return '<span class="text-blue edit">'+ value +'</span>';
                            }
                        }
                    }]
                });
            },
            // 列表
            getZjnList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                Vue.axios.post('Printer/getConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.total,
                            rows: res.data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 设置
            zjnSub: function(shop_id) {
                const _this = this;

                layer.confirm('', {
                    type: 1,
                    skin: 'public-alert-skin',
                    btn: ['确定', '取消'], // 按钮
                    title: '账单结尾内容定义',
                    area: ['450px', ''], // 宽高
                    content: $(_this.$refs.zjn_usetime_alert)
                }, function() {
                    let bill_foot_content = '';
                    if(_this.zjn_usetime_allday == '') {
                        bill_foot_content = _this.zjn_txt;
                    }
                    Vue.axios.post('Printer/editConfig', {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "shop_id": shop_id,
                                "bill_foot_content": bill_foot_content
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            layer.closeAll();
                            layer.msg('修改成功');
                            $(_this.$refs.zjnList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg("出错啦");
                    });
                });
            },


            /*
             * 员工还款后打印商品订单
             */
            innitYhdTable: function() {
                let _this = this;
                $(_this.$refs.yhdList).bootstrapTable('destroy');
                $(_this.$refs.yhdList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getYhdList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "print_after_user_paid",
                        title: "是否员工还款后打印商品订单",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.yhdSub(row.shop_id, check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 列表
            getYhdList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                Vue.axios.post('Printer/getConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.total,
                            rows: res.data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 设置
            yhdSub: function(shop_id, check_stock) {
                const _this = this;

                Vue.axios.post('Printer/editConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            "print_after_user_paid": check_stock
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.yhdList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },


            /*
             * 打印单据的会员信息是否隐藏
             */
            innitDyxTable: function() {
                let _this = this;
                $(_this.$refs.dyxList).bootstrapTable('destroy');
                $(_this.$refs.dyxList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getDyxList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "20%"
                    }, {
                        field: "print_hide_vip_name",
                        title: "打印的单据会员姓名是否隐藏",
                        width: "20%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.dyxSub(row.shop_id, 'print_hide_vip_name', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "print_hide_vip_level",
                        title: "打印的单据会员等级是否隐藏",
                        width: "20%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.dyxSub(row.shop_id, 'print_hide_vip_level', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "print_hide_vip_mobile",
                        title: "打印的单据会员手机号是否隐藏",
                        width: "20%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.dyxSub(row.shop_id, 'print_hide_vip_mobile', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "print_hide_vip_card",
                        title: "打印的单据会员卡号是否隐藏",
                        width: "20%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.dyxSub(row.shop_id, 'print_hide_vip_card', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 列表
            getDyxList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                Vue.axios.post('Printer/getConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.total,
                            rows: res.data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 设置
            dyxSub: function(shop_id, key, check_stock) {
                const _this = this;

                Vue.axios.post('Printer/editConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            [key]: check_stock
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.dyxList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },


            /*
             * 付款记录经理实收原因及支付卡号是否隐藏
             */
            innitFskTable: function() {
                let _this = this;
                $(_this.$refs.fskList).bootstrapTable('destroy');
                $(_this.$refs.fskList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getFskList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "25%"
                    }, {
                        field: "pay_log_hide",
                        title: "付款记录是否隐藏",
                        width: "25%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.fskSub(row.shop_id, 'pay_log_hide', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "pay_log_hide_manage_reason",
                        title: "付款记录经理实收原因是否隐藏",
                        width: "25%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.fskSub(row.shop_id, 'pay_log_hide_manage_reason', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            let disabled = row.pay_log_hide == '1' ? 'disabled' : ''
                            let style = row.pay_log_hide == '1' ? " style='background:#efefef'" : ''
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'" + disabled + style + "><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'" + disabled + style + "><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "pay_log_hide_vip_card",
                        title: "付款记录支付卡号是否隐藏",
                        width: "25%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.fskSub(row.shop_id, 'pay_log_hide_vip_card', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            let disabled = row.pay_log_hide == '1' ? 'disabled' : ''
                            let style = row.pay_log_hide == '1' ? " style='background:#efefef'" : ''
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'" + disabled + style + "><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'" + disabled + style + "><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 列表
            getFskList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                Vue.axios.post('Printer/getConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.total,
                            rows: res.data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 设置
            fskSub: function(shop_id, key, check_stock) {
                const _this = this;

                Vue.axios.post('Printer/editConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            [key]: check_stock
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.fskList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },


            /*
             * 账单打印内容是否包含送花账单信息
             */
            innitZdbsTable: function() {
                let _this = this;
                $(_this.$refs.zdbsList).bootstrapTable('destroy');
                $(_this.$refs.zdbsList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getZdbsList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "merge_flower_bill_print",
                        title: "账单打印内容是否包含送花账单信息",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.zdbsSub(row.shop_id, check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='2'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='2' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 列表
            getZdbsList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                Vue.axios.post('Shop/getConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "config_type": "merge_flower_data"
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.count,
                            rows: res.data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 设置
            zdbsSub: function(shop_id, check_stock) {
                const _this = this;

                Vue.axios.post('Shop/upConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": shop_id,
                            "config": check_stock,
                            "config_type": "merge_flower_bill_print"
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.zdbsList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            /*
             * 商品备货单是否显示合计金额
             */
            innitSbhTable: function() {
                let _this = this;
                $(_this.$refs.sbhList).bootstrapTable('destroy');
                $(_this.$refs.sbhList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getSbhList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "inventory_show_total_amount",
                        title: "商品备货单是否显示合计金额",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.sbhSub(row.shop_id, 'inventory_show_total_amount', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 列表
            getSbhList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                Vue.axios.post('Printer/getConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.total,
                            rows: res.data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 设置
            sbhSub: function(shop_id, key, check_stock) {
                const _this = this;

                Vue.axios.post('Printer/editConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            [key]: check_stock
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('修改成功');
                        $(_this.$refs.sbhList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },


            /*
             * 账单打印是否显示套餐明细
             */
            // 初始化账单打印是否显示套餐明细
            innitZdxtmTable: function() {
                let _this = this;
                $(_this.$refs.zdxtmList).bootstrapTable('destroy');
                $(_this.$refs.zdxtmList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getFskList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "bill_print_package_detail",
                        title: "账单打印是否显示套餐明细",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.fskSub(row.shop_id, 'bill_print_package_detail', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(row.bill_print_package_detail == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "bill_print_ware_goods_amount",
                        title: "账单打印是否显示套餐明细金额",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.fskSub(row.shop_id, 'bill_print_ware_goods_amount', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(row.bill_print_ware_goods_amount == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },


            /*
             * 账单打印是否显示低消金额
             */
            // 初始化账单打印是否显示低消金额列表
            innitZdxdxTable: function() {
                let _this = this;
                $(_this.$refs.zdxdxList).bootstrapTable('destroy');
                $(_this.$refs.zdxdxList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getFskList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "25%"
                    }, {
                        field: "bill_print_minimum_balance_amount",
                        title: "计时低消差额是否显示",
                        width: "25%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.fskSub(row.shop_id, 'bill_print_minimum_balance_amount', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(row.bill_print_minimum_balance_amount == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "bill_print_minimum_amount",
                        title: "计入低消金额是否显示",
                        width: "25%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.fskSub(row.shop_id, 'bill_print_minimum_amount', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(row.bill_print_minimum_amount == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "bill_print_no_minimum_amount",
                        title: "非低消金额是否显示",
                        width: "25%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.fskSub(row.shop_id, 'bill_print_no_minimum_amount', check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(row.bill_print_no_minimum_amount == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            
        }
    }
</script>
<style lang="less" scoped>
    .rowpadding {
        margin: 0 0 36px;
    }

    // 商品总单打印设置
    .store-szd-set {
        .szd-modify {
            display: none;
            .szd-modify-shop {
                line-height: 32px;
                background: #DDD;
            }
            .szd-sel-list {
                padding: 0;
                border: 1px solid #CCC;
                h3 {
                    border-bottom: 1px solid #CCC;
                    margin: 0;
                    line-height: 40px;
                    color: #757575;
                    font-size: 14px;
                    text-align: center;
                }
                ul {
                    margin: 50px 0 30px;
                }
                li {
                    float: left;
                    width: 155px;
                    border: 1px solid #CCC;
                    margin: 0 0 20px 22px;
                    line-height: 30px;
                    color: #757575;
                    text-align: center;
                    cursor: pointer;
                    border-radius: 15px;
                }
                .szd-sel-li {
                    border: 1px solid #009af0;
                    color: #009af0;
                }
            }
        }
    }

    // 账单结尾内容定义
    .store-zjn-set {
        .zjn-usetime-allday {
            margin: 0 0 10px;
        }
    }
</style>